import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../../utils/apiClient';

/**
 * Хук настроек конфиденциальности текущего пользователя.
 * whoCanMessage / whoCanCall: 'all' | 'subscribers' | 'nobody'
 */
export function usePrivacySettings() {
    const [settings, setSettings] = useState({ whoCanMessage: 'all', whoCanCall: 'all' });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await apiFetch('/api/user/settings/privacy', { method: 'GET' });
                const data = await res.json().catch(() => ({}));
                if (!cancelled && res.ok) {
                    setSettings({
                        whoCanMessage: data?.whoCanMessage ?? 'all',
                        whoCanCall: data?.whoCanCall ?? 'all',
                    });
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    const update = useCallback(async (patch) => {
        setSaving(true);
        // оптимистично обновляем UI
        setSettings((prev) => ({ ...prev, ...patch }));
        try {
            const res = await apiFetch('/api/user/settings/privacy', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(patch),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok) {
                setSettings({
                    whoCanMessage: data?.whoCanMessage ?? 'all',
                    whoCanCall: data?.whoCanCall ?? 'all',
                });
            }
            return data;
        } finally {
            setSaving(false);
        }
    }, []);

    return { settings, loading, saving, update };
}
